import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Billing() {
  const { user } = useAuth();
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    if (user?.property_id) {
      api.get(`/billing/config?property_id=${user.property_id}`).then(r => setCfg(r.data));
    }
  }, [user?.property_id]);

  const save = async () => {
    try {
      const payload = { ...cfg, property_id: user.property_id };
      ["entry_fee","first_hours","first_hours_fee","succeeding_hour_fee","daily_rate","overnight_rate","lost_ticket_fee","grace_minutes","holiday_multiplier","weekend_multiplier"]
        .forEach(k => { payload[k] = Number(payload[k]) || 0; });
      await api.put("/billing/config", payload);
      toast.success("Billing config saved");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Save failed");
    }
  };

  if (!cfg) return <div className="text-zinc-500">Loading…</div>;
  const fields = [
    ["entry_fee", "Entry Fee (₱)"],
    ["first_hours", "First Hours Bucket"],
    ["first_hours_fee", "First-Hours Fee (₱)"],
    ["succeeding_hour_fee", "Succeeding Hour Fee (₱)"],
    ["daily_rate", "Daily Rate (₱)"],
    ["overnight_rate", "Overnight Rate (₱)"],
    ["lost_ticket_fee", "Lost Ticket Fee (₱)"],
    ["grace_minutes", "Grace Period (mins)"],
    ["holiday_multiplier", "Holiday Multiplier"],
    ["weekend_multiplier", "Weekend Multiplier"],
  ];
  return (
    <div className="space-y-6">
      <header>
        <p className="text-xs font-mono uppercase tracking-[0.3em] text-zinc-500">Billing Config</p>
        <h1 className="font-heading text-4xl font-black tracking-tighter mt-1">Rate cards.</h1>
        <p className="text-sm text-zinc-500 mt-1">Used by the guest billing engine to compute fees on exit.</p>
      </header>
      <Card className="bg-[#141414] border-zinc-800 p-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {fields.map(([k, label]) => (
            <div key={k}>
              <Label className="text-xs font-mono uppercase tracking-widest text-zinc-500">{label}</Label>
              <Input
                type="number"
                value={cfg[k] ?? 0}
                onChange={(e) => setCfg({ ...cfg, [k]: e.target.value })}
                className="bg-[#0F0F10] border-zinc-800 font-mono mt-1"
                data-testid={`billing-${k}-input`}
              />
            </div>
          ))}
        </div>
        <Button onClick={save} className="mt-6 bg-white text-black hover:bg-zinc-200" data-testid="billing-save-button">Save Configuration</Button>
      </Card>
    </div>
  );
}
